import axios from 'libs/fetch'
import { useQuery } from 'libs/query'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import type { Store, StoreRes } from 'types/store'
import type { PayoutMethod } from 'shared/types/payout.types'

type PayoutMethodsData = {
	payoutMethods: PayoutMethod[]
	bankAccountPlaceholder: string | null
	country: string | null
}

const selectPayoutMethods = ({ data }: StoreRes): PayoutMethodsData => ({
	payoutMethods: data.payout_methods ?? [],
	bankAccountPlaceholder: data.bank_account_placeholder ?? null,
	country: data.country ?? null
})

export const useFetchPayoutMethods = () => {
	const { data, isLoading: isPayoutMethodsLoading } = useQuery({
		queryKey: queryKeys.payoutMethods.all,
		queryFn: () => axios.get<Store>(apiRoutes.store),
		select: selectPayoutMethods,
		refetchOnWindowFocus: false
	})

	return {
		payoutMethods: data?.payoutMethods ?? [],
		bankAccountPlaceholder: data?.bankAccountPlaceholder ?? null,
		country: data?.country ?? null,
		isPayoutMethodsLoading
	}
}
